// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da

import {
  LOGIN_SET_CHANGE_PASSWORD_LOADING,
} from './constants';

export function setChangePasswordLoading() {
  return {
    type: LOGIN_SET_CHANGE_PASSWORD_LOADING,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case LOGIN_SET_CHANGE_PASSWORD_LOADING:
      return {
        ...state,
        changePasswordLoading:1
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/login/redux/setChangePasswordLoading.js